import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=6fada383&scoped=true"
import script from "./AppDownload.vue?vue&type=script&lang=js"
export * from "./AppDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fada383",
  null
  
)

export default component.exports